import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { TFormValues } from '../productForm.types'
import { IntegrationType } from '../../../../server/mpsklad_core/Entity/IntegrationType'
import { observer } from 'mobx-react-lite'
import { MarketplaceAttributesBlock } from './marketplaceAttributesBlock'
import { useAttributeLoading } from '../lib/attributeLoadingContext'

export const MarketplacesFields = observer(() => {
  const {control} = useFormContext<TFormValues>()

  const {loading} = useAttributeLoading()

  const {fields: ozonFields} = useFieldArray({
    control,
    name: 'ozon.attributes',
    keyName: '_id'
  })

  const {fields: wbFields} = useFieldArray({
    control,
    name: 'wildberries.attributes',
    keyName: '_id'
  })

  const {fields: ymFields} = useFieldArray({
    control,
    name: 'yandexMarket.attributes',
    keyName: '_id'
  })

  return <>
    <MarketplaceAttributesBlock
      integrationType={IntegrationType.Ozon}
      fields={ozonFields}
      loading={loading[IntegrationType.Ozon]}
      fieldFormName="ozon.attributes"
    />

    <MarketplaceAttributesBlock
      integrationType={IntegrationType.Wildberries}
      fields={wbFields}
      loading={loading[IntegrationType.Wildberries]}
      fieldFormName="wildberries.attributes"
    />

    <MarketplaceAttributesBlock
      integrationType={IntegrationType.YandexMarket}
      fields={ymFields}
      loading={loading[IntegrationType.YandexMarket]}
      fieldFormName="yandexMarket.attributes"
    />
  </>
})
